import { connect } from 'react-redux';
import { addArtToCart, addOriginalArtToCart, addFrameToCart } from 'arts/actions/cart_items';
import AddToCart from './add_to_cart';

const mapStateToProps = ({ cartItems: { adding, added, error } }) => ({
  added, adding, failed: !!error
});

export default connect(mapStateToProps, {
  addArtToCart, addOriginalArtToCart, addFrameToCart
})(AddToCart);
